The type of event.

See `Event` implementations for a list of supported values.
